import { render } from "./IconReplace.vue?vue&type=template&id=44787e56"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconReplace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44787e56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44787e56', __exports__)) {
    api.reload('44787e56', __exports__)
  }
  
  module.hot.accept("./IconReplace.vue?vue&type=template&id=44787e56", () => {
    api.rerender('44787e56', render)
  })

}


export default __exports__